export const NO_OF_COPIES_MIN = 1;
export const NO_OF_COPIES_MAX = 10;

export const NO_OF_COPIES_ERROR = `Must be between ${NO_OF_COPIES_MIN} and ${NO_OF_COPIES_MAX}`;

/** Merge no_of_copies errors into an existing Formik errors object. */
export function applyNoOfCopiesValidation(values, errors = {}) {
    if (values.no_of_copies !== undefined && values.no_of_copies !== '') {
        const num = parseInt(values.no_of_copies, 10);
        if (isNaN(num) || num < NO_OF_COPIES_MIN || num > NO_OF_COPIES_MAX) {
            errors.no_of_copies = NO_OF_COPIES_ERROR;
        }
    }
    return errors;
}

export function handleNoOfCopiesInputChange(e, formik) {
    let value = e.target.value.replace(/[^0-9]/g, '');
    if (value === '') {
        formik.setFieldValue('no_of_copies', '');
        return;
    }
    const number = Number(value);
    if (number >= NO_OF_COPIES_MIN && number <= NO_OF_COPIES_MAX) {
        formik.setFieldValue('no_of_copies', value);
    } else {
        e.target.value = formik.values.no_of_copies || '';
    }
}

export function handleTypeOfBlSelectChange(option, formik) {
    const nextType = option ? option.value : '';
    formik.setFieldValue('type_of_bl', nextType);
    if (!nextType) {
        formik.setFieldValue('no_of_copies', '');
    }
}
